import { createAction } from "@reduxjs/toolkit";

export const setSuccess = createAction<boolean>("onboarding/setSuccess");
